const status_text = {
    requestStatusText(status) {
        let text = "";

        switch (status) {
            case 10:
                text = "รอชำระเงินและยื่นเอกสาร";
                break;
            case 20:
                text = "รอการยื่นเอกสาร";
                break;
            case 21:
                text = "รับเอกสารเทคนิคแล้ว";
                break;
            case 22:
                text = "รับเอกสารราคาแล้ว";
                break;
            case 23:
                text = "อัพโหลดเอกสารเทคนิคแล้ว";
                break;
            case 30:
                text = "รอตรวจเอกสารเทคนิค";
                break;
            case 31:
                text = "เอกสารเทคนิคไม่ครบถ้วน";
                break;
            case 32:
                text = "รอยื่นเอกสารเพิ่มเติม";
                break;
            case 40:
                text = "รอพิจารณาเทคนิค";
                break;
            case 50:
                text = "ผ่านการพิจารณาทางเทคนิค";
                break;
            case 51:
                text = "ไม่ผ่านการพิจารณาทางเทคนิค";
                break;
            case 60:
                text = "ผ่านการพิจารณาราคา";
                break;
            case 61:
                text = "ไม่ผ่านการพิจารณาราคา";
                break;
            case 90:
                text = "เลขที่คำเสนอขอขายไฟฟ้าถูกยกเลิก";
                break;
        }
        return text;
    },
    paymentStatusText(status) {
        let text = "";

        switch (status) {
            case 0:
                text = "-";
                break;
            case 10:
                text = "รอการวางเงินค้ำประกัน";
                break;
            case 20:
                text = "วางเงินค้ำประกันแล้ว";
                break;
            case 30:
                text = "รอคืนเงินประกัน";
                break;
            case 40:
                text = "อนุมัติคืนเงินประกัน";
                break;
            case 50:
                text = "ยึดหลักประกัน";
                break;
            case 90:
                text = "เกินกำหนดเวลาชำระเงิน";
                break;
        }
        return text;
    }
};

export default status_text;
